module.exports = __webpack_public_path__ + "static/img/file.dde5f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/file.png
// module id = 3oot
// module chunks = 7